module.exports = __webpack_public_path__ + "media/home.83ca5cd0.mp4";